import { alpha, styled } from '@mui/material';

export const GroupHeaderRow = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: -2,
  zIndex: 1,
  display: 'flex',
  cursor: 'pointer',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  margin: theme.spacing(0.5, 0),
  padding: theme.spacing(0.75, 1.25),
  borderRadius: 8,
  fontSize: '0.7rem',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create(['background-color', 'border-color']),
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
}));
